module.exports = __webpack_public_path__ + "media/images/talent/img-conversion-2a537ad443b9405dedb6000a1890085b.png";